<app-sidebar-nav-items
  class="nav"
  [user]="user"
  [items]="navItemsArray">
</app-sidebar-nav-items>
